import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';
import { authReducer, State as AuthState } from './core/auth/auth.reducer';
import { dashboardReducer, State as DashboardState } from './core/dashboard-page/dashboard.reducer';
import { dialogReducer, State as DialogState } from './core/dialog/dialog.reducer';
import { reducer as layersReducer, State as LayersState } from './core/map/layers/layers.reducer';
import { mapReducer, State as MapState } from './core/map/map.reducer';
import { notificationsReducer, State as NotificationsState } from './core/notifications/notifications.reducer';
import { parcelReducer } from './core/properties-table/properties.reducer';
import { State as PropertiesState } from './core/properties-table/properties.state';
import { reportReducer } from './core/report/report.reducer';
import { summaryReducer } from './core/summary-sheet/summary-sheet.reducer';


export interface State {
    router: RouterReducerState;
    dialog: DialogState;
    auth: AuthState;
    dashboard: DashboardState;
    map: MapState;
    layers: LayersState;
    properties: PropertiesState;
    notifications: NotificationsState;
}

export function mergedPropertiesReducers(state: any, action: any) {
    return parcelReducer(summaryReducer(reportReducer(state, action), action), action);
}


export const reducers = {
    router: routerReducer,
    dialog: dialogReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    map: mapReducer,
    layers: layersReducer,
    properties: mergedPropertiesReducers,
    notifications: notificationsReducer,
};

export const getState = (state: State) => state;

export const getGlobalState = createSelector(getState, state => state);
